import script from "./SegmentationCustomerTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SegmentationCustomerTable.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__